module.exports = __webpack_public_path__ + "static/test-d39eb7b0ad27cd34cabad9596b707330.pdf";